import {
    CacheType,
    createObservableDataAction,
    IActionContext,
    IActionInput
} from '@msdyn365-commerce/core';
import { laybuyCreateOrderAsync } from '../../../data-actions/generated/DataActionExtension.g';

/**
 * Laybuy CreateOrderInput Input Action
 */
export class CreateOrderInput implements IActionInput {
    // tslint:disable-next-line: no-any
    public orderData: any;

    // tslint:disable-next-line: no-any
    constructor (input: any) {
        this.orderData = input;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `LaybuyCreateOrder ${JSON.stringify(this.orderData)}`;
    public getCacheObjectType = () => `LaybuyCreateOrder`;
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
// tslint:disable-next-line: no-any
const createInput = (args: any): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
// tslint:disable-next-line
async function action(input: any, ctx: IActionContext) {
    const result = await laybuyCreateOrderAsync({ callerContext: ctx }, JSON.stringify(input.orderData));
    return Array.isArray(result) ? result[0] : result;
}

export const ICreateOrderAction =  createObservableDataAction({
    action: action,
    input: createInput
});
